import * as focusTrap from "focus-trap"; // ESM
import SearchToggleControl from "./SearchToggleControl";

/**
 * The Search class that initialises all the controls.
 * Indicated by the data attribute:
 *  [data-search-toggle]
 */
export default class SearchToggle {
  /**
   * Static active class, should not change unless altered from the CSS
   * for some reason
   *
   * Used to animate the menu content targets
   */
  static activeClass = "active";

  /**
   * Static locked class, should not change unless altered from the CSS
   * for some reason
   *
   * Used to lock the body content from
   */
  static lockedClass = "locked";

  /**
   * Static transition class, should not change unless altered from the CSS
   * for some reason
   *
   * Applied at the start of the opening transition
   * Removed at the end of the closing transition
   */
  static transitionClass = "transitioning";

  /**
   * The active target for the MainNavigationControl classes
   * Serves as a single point of reference for all controls in the
   * Main Navigation
   */
  static activeTarget = "";

  /**
   * The focus trap functionality for the main navigation
   * Serves as a single point of reference for all controls in the
   * Main Navigation to control the focus trap
   */
  static focusTrap = () => {};

  /**
   * Construct the main navigation functionality from its root
   * Find the menu, controls and their targets through data attributes:
   *  [data-control-search]
   *  [data-control]
   *  [data-controlled-by]
   *
   * Passes this data through as config for each Control to keep track of.
   *
   * @param {HTMLDivElement} element
   */
  constructor(element) {
    this.page = document.querySelector(".page-wrapper");
    this.root = element;
    this.menu = this.root.querySelector("[data-control-search]");
    this.targets = this.root.querySelectorAll("[data-controlled-by]");
    this.controls = [];
    // Focus Trap
    SearchToggle.setFocusTrap(focusTrap.createFocusTrap(this.menu));

    // Initialise all the controls
    const controlBtns = this.root.querySelectorAll(
      "[data-search-control='search-wide']",
    );
    controlBtns.forEach((control) => {
      // Push each control to the controls property for reference by the controls
      this.controls.push(
        new SearchToggleControl({
          element: control,
          page: this.page,
          root: this.root,
          menu: this.menu,
          controls: this.controls,
          allTargets: this.targets,
        }),
      );
    });
  }

  // Controls which target is currently open for the buttons
  static setActiveTarget(value) {
    SearchToggle.activeTarget = value;
  }

  // Assign focus trap to the main navigation
  static setFocusTrap(value) {
    SearchToggle.focusTrap = value;
  }
}
